import type { CostsAction } from './actions';
import { ActionTypes } from './actionTypes';
import { type Draft, produce } from 'immer';
import type { Reducer } from 'redux';

import type { DriverNames, FuelCosts, MaintenanceCosts } from '@cobliteam/common-types';

import { isWebDataSuccess, type WebData, webDataError, webDataFetching, webDataNotAsked, webDataSuccess } from '@cobliteam/api-lib';

export interface CostsState {
  fuelCostsWebData: WebData<FuelCosts>;
  maintenanceCostsWebData: WebData<MaintenanceCosts>;
  driverNamesByIdWebData: WebData<DriverNames>;
  costsReportWebData: WebData<void>;
}

export const costsInitialState: CostsState = {
  fuelCostsWebData: webDataNotAsked(),
  maintenanceCostsWebData: webDataNotAsked(),
  driverNamesByIdWebData: webDataNotAsked(),
  costsReportWebData: webDataNotAsked(),
};

export const costsReducer: Reducer<CostsState, CostsAction> = produce((draft: Draft<CostsState>, action: CostsAction) => {
  switch (action.type) {
    case ActionTypes.LOAD_COSTS_REQUEST:
      draft.fuelCostsWebData = webDataFetching();
      draft.maintenanceCostsWebData = webDataFetching();
      draft.driverNamesByIdWebData = webDataFetching();
      break;

    case ActionTypes.LOAD_COSTS_SUCCEEDED:
      const { maintenanceCosts, fuelCosts } = action.payload;

      draft.fuelCostsWebData = webDataSuccess(fuelCosts);
      draft.maintenanceCostsWebData = webDataSuccess(maintenanceCosts);
      break;

    case ActionTypes.LOAD_COSTS_FAILED:
      draft.fuelCostsWebData = webDataError();
      draft.maintenanceCostsWebData = webDataError();
      draft.driverNamesByIdWebData = webDataError();
      break;

    case ActionTypes.LOAD_DRIVERS_NAME_SUCCEEDED:
      if (isWebDataSuccess(draft.driverNamesByIdWebData)) {
        draft.driverNamesByIdWebData = webDataSuccess({
          ...draft.driverNamesByIdWebData.data,
          ...action.payload,
        });
      } else {
        draft.driverNamesByIdWebData = webDataSuccess(action.payload);
      }
      break;

    case ActionTypes.DOWNLOAD_COSTS_REQUEST:
      draft.costsReportWebData = webDataFetching();
      break;

    case ActionTypes.DOWNLOAD_COSTS_END:
      draft.costsReportWebData = webDataNotAsked();
      break;
  }
}, costsInitialState);
